import { enqueueSnackbar } from 'notistack';

const defaultOptions = {
  autoHideDuration: 1500,
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
};

// Success Toast
const success = (message) => {
  enqueueSnackbar(message, {
    ...defaultOptions,
    variant: 'success',
    style: { backgroundColor: '#5e5acf', color: '#fff' },
  });
};

// Error Toast
const error = (message) => {
  enqueueSnackbar(message, {
    ...defaultOptions,
    variant: 'error',
    style: { backgroundColor: '#d9534f', color: '#fff' },
  });
};

// Warning Toast
const warning = (message) => {
  enqueueSnackbar(message, {
    ...defaultOptions,
    variant: 'warning',
    style: { backgroundColor: '#f0ad4e', color: '#fff' },
  });
};

// Info Toast
const info = (message) => {
  enqueueSnackbar(message, {
    ...defaultOptions,
    variant: 'info',
    style: { backgroundColor: '#5bc0de', color: '#fff' },
  });
};

// Export as an object
const ToastService = { success, error, warning, info };

export default ToastService;
